<template>
  <div id="tweetPictures">
    <div class="faultClass container">
      <h4>权益池管理</h4>
      <ul class="clearfix" style="overflow-y:auto">
        <li
          v-for="(item, index) in dataList"
          :key="index"
          class="faultClassListPart listPart"
        >
          {{ item.name }}
          <span class="exitBtn" @click.stop="editInfo(item)">编辑</span>
        </li>
        <li class="addContent" @click="addInfo">
          <i class="el-icon-plus"></i>
        </li>
      </ul>
    </div>
    <biz-privilege-pool-info
      ref="infoRef"
      @refresh="loadPage"
    ></biz-privilege-pool-info>
  </div>
</template>
<script>
import { bizPrivilegePoolsPage, bizPrivilegePoolsList } from "@/api/privilege";
import BizPrivilegePoolInfo from "./components/info.vue";

export default {
  components: {
    BizPrivilegePoolInfo
  },
  data() {
    return {
      dataList: [],
      listLoading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  mounted() {
    this.loadPage(1);
  },
  methods: {
    loadPage(page) {
      // if (page) {
      //   this.pageNum = page;
      // } else {
      //   this.pageNum += 1;
      // }
      // this.listLoading = true;
      // const query = {
      //   pageNum: this.pageNum,
      //   pageSize: this.pageSize
      // };
      // bizPrivilegePoolsPage(query)
      //   .then(resp => {
      //     if (resp.data.status == 100) {
      //       if (this.pageNum == 1) {
      //         this.dataList = resp.data.results.list;
      //       } else {
      //         this.dataList = this.dataList.concat(resp.data.results.list);
      //       }
      //       this.total = resp.data.results.total;
      //     } else {
      //       this.$message({
      //         message: resp.data.message,
      //         type: "error"
      //       });
      //     }
      //     this.listLoading = false;
      //   })
      //   .finally(() => {
      //     this.listLoading = false;
      //   });

      this.listLoading = true;
      bizPrivilegePoolsList()
        .then(resp => {
          if (resp.data.status == 100) {
            this.dataList = resp.data.results;
          } else {
            this.$message({
              message: resp.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    addInfo() {
      this.$refs.infoRef.open();
    },
    editInfo(info) {
      this.$refs.infoRef.open(info);
    }
  }
};
</script>

<style lang="scss" scoped>
#tweetPictures {
  .clearfix {
    clear: both;
    // overflow: hidden;
    overflow: auto;
    max-height: 1024px;
  }
  .container {
    border-bottom: 1px solid #c6c6c6;
    padding-bottom: 20px;
    h4 {
      margin: 15px 0;
      font-weight: 500;
      font-size: 16px;
    }
    .listPart {
      width: 160px;
      float: left;
      border: 1px solid #10c55b;
      margin: 0 15px 10px 0;
      border-radius: 10px;
      min-height: 40px;
      line-height: 1.8;
      padding: 20px 0 40px;
      text-align: center;
      position: relative;
      z-index: 0;
      cursor: pointer;
      font-size: 13px;
      & > span:first-child {
        display: none;
      }
      p {
        width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 1.8;
        text-align: center;
        font-size: 13px;
      }
      span.active {
        position: absolute;
        top: -1px;
        right: -1px;
        display: block;
        width: 30px;
        height: 30px;
        border-width: 16px;
        border-style: solid;
        border-color: #1abc9c #1abc9c #fff #fff;
        border-top-right-radius: 10px;
        i {
          position: absolute;
          font-size: 14px;
          color: #fff;
          top: -9px;
        }
      }
      span.exitBtn {
        position: absolute;
        bottom: 0;
        width: 100%;
        line-height: 20px;
        left: 0;
        border-top: 1px solid #10c55b;
        z-index: 1;
        display: block;
        background-color: #d7ffe8;
        border-radius: 0 0 10px 10px;
        color: #10c55b;
      }
      span.warning {
        color: #e03b5b;
        background-color: #f8d7da;
        border-top: 1px solid #e03b5b;
      }
      i.activeDelBtn {
        display: none;
        position: absolute;
        top: 5px;
        left: 5px;
        color: #e03b5b;
      }
    }
    .warning-border {
      border: 1px solid #e03b5b;
    }

    .listPart:hover {
      box-shadow: 2px 2px 2px #c6c6c6;
    }
    .listPart:hover i.activeDelBtn {
      display: block;
    }
    .addContent {
      border: 1px dashed #c6c6c6;
      width: 50px;
      height: 50px;
      line-height: 50px;
      float: left;
      text-align: center;
      margin-top: 15px;
      cursor: pointer;
      i {
        font-size: 20px;
      }
    }
    .contentPart {
      width: 80px;
      float: left;
      border: 1px solid #c6c6c6;
      margin: 0 15px 10px 0;
      border-radius: 5px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      position: relative;
      z-index: 0;
      cursor: pointer;
    }
    .activeContent {
      background-color: #1abc9c;
      color: #fff;
      border-color: #fff;
    }
  }
  .container:last-child {
    border-color: transparent;
  }
  .explain {
    font-size: 12px;
    color: #999;
    margin-top: 10px;
    line-height: 1.5;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?a1051848